import {
  Action_GetAllRoleInUser,
  Action_GetAllRoleInUserSuccess,
  Action_GetAllUser,
  Action_GetAllUserSuccess
} from "./actionTypes";

// Sự kiện lưu 
export const Index_GetAllRoleInUser = (data) => ({
  type: Action_GetAllRoleInUser,
  payload: data
});
export const Index_GetAllRoleInUserSuccess = (data) => ({
  type: Action_GetAllRoleInUserSuccess,
  payload: data,
});
//////////////////////////////
export const Index_GetAllUser = (data) => ({
  type: Action_GetAllUser,
  payload: data
});
export const Index_GetAllUserSuccess = (data) => ({
  type: Action_GetAllUserSuccess,
  payload: data,
});
//////////////////////////////

